import { render, staticRenderFns } from "./partner-applicant-list.vue?vue&type=template&id=21958a5d&scoped=true&"
import script from "./partner-applicant-list.vue?vue&type=script&lang=js&"
export * from "./partner-applicant-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21958a5d",
  null
  
)

export default component.exports